import { render } from "./AllParks.vue?vue&type=template&id=483281fe&scoped=true"
import script from "./AllParks.vue?vue&type=script&lang=js"
export * from "./AllParks.vue?vue&type=script&lang=js"

import "./AllParks.vue?vue&type=style&index=0&id=483281fe&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-483281fe"

export default script